import { PortalPjLayout } from '@/components/layout/PortalPjLayout'
import { PortalPjBody } from '@/components/PortalPj/PortalPjBody'
import { getRoleFallbackPath, isPjRole } from '@/config/routeAccess'
import { usePortalPjPage } from '@/hooks/usePortalPjPage'
import { useAuthStore } from '@/stores/authStore'

export default function PortalPj() {
  const role = useAuthStore((s) => s.user?.role) ?? 'usuario_agrada'
  const isPjOnly = isPjRole(role)
  const page = usePortalPjPage()
  const crmHomeHref = isPjOnly ? undefined : getRoleFallbackPath(role, '/portal')

  return (
    <PortalPjLayout
      activeTab={page.tab}
      onTabChange={page.setTab}
      crmHomeHref={crmHomeHref}
    >
      <PortalPjBody {...page} hideEmpresaSearch={isPjOnly} embedded={false} />
    </PortalPjLayout>
  )
}
